import React from 'react'
import type { GridBlock as BlockProps } from '@/payload-types'
import { Grid } from '@/components/Grid'
import { RenderBlocks } from '@/blocks/RenderBlocks'

export const GridBlock: React.FC<BlockProps> = ({
  layout,
  center,
  narrow,
  layoutType,
  layoutGaps,
}) => {
  return (
    <Grid
      center={center || undefined}
      narrow={narrow || undefined}
      layoutType={layoutType || undefined}
      layoutGaps={layoutGaps || undefined}
    >
      <RenderBlocks blocks={layout ?? []} />
    </Grid>
  )
}
